import { a as __rest } from '../../_tslib.esm.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import linkStyles from './Link.styles.esm.js';
import { LinkAnchor } from './LinkAnchor.esm.js';
import { LinkButton } from './LinkButton.esm.js';

// Link component (supports both <a>, <button>, and <NextLink> tags)
const Link = React__default.forwardRef((_a, ref) => {
  var {
      className,
      children,
      icon,
      inverse = false,
      size = "md",
      weight = "regular",
      iconPosition = "left",
      variant = "inline",
      asChild,
      href
    } = _a,
    props = __rest(_a, ["className", "children", "icon", "inverse", "size", "weight", "iconPosition", "variant", "asChild", "href"]);
  const {
    base: baseClasses,
    icon: iconClasses
  } = linkStyles({
    variant,
    size,
    iconPosition,
    weight,
    inverse
  });
  const content = jsxs(Fragment, {
    children: [React__default.isValidElement(icon) && iconPosition && React__default.cloneElement(icon, {
      className: `${iconClasses()} ${icon.props.className || ""}`
    }), children]
  });
  // NextLink case
  if (asChild) {
    return jsx("span", Object.assign({
      ref: ref,
      className: baseClasses({
        class: className
      }),
      tabIndex: 0
    }, props, {
      children: content
    }));
  }
  if (href) {
    return jsx(LinkAnchor, Object.assign({
      ref: ref,
      className: baseClasses({
        class: className
      }),
      tabIndex: 0,
      href: href
    }, props, {
      children: content
    }));
  }
  return jsx(LinkButton, Object.assign({
    ref: ref,
    className: baseClasses({
      class: className
    }),
    tabIndex: 0
  }, props, {
    children: content
  }));
});
// Add display name for better debugging
Link.displayName = "Link";

export { Link };
